import { useTranslation } from 'react-i18next';
import { NavLink, Outlet } from 'react-router';

import { useViewer } from '@/entities/viewer';
import { LocaleSwitcher } from '@/features/locale-switcher';

import styles from './RootLayout.module.css';

/** Public pages: landing, login, register. */
export function RootLayout() {
  const { t } = useTranslation();
  const viewer = useViewer();
  return (
    <div className={styles.shell}>
      <header className={styles.header}>
        <NavLink to="/" className={styles.brand}>
          {t('app.name')}
        </NavLink>
        <nav className={styles.nav}>
          {viewer.status === 'authenticated' ? (
            <NavLink to="/app">{t('nav.openApp')}</NavLink>
          ) : (
            <>
              <NavLink to="/login">{t('auth.signIn')}</NavLink>
              <NavLink to="/register">{t('auth.signUp')}</NavLink>
            </>
          )}
        </nav>
        {viewer.status !== 'authenticated' && <LocaleSwitcher />}
      </header>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
